import React from 'react';
import Button from '../ui/Button';
import { StarIcon, CheckCircleIcon, MessageCircleIcon, ArrowDownIcon } from 'lucide-react';
import YouTubeEmbed from '../ui/YouTubeEmbed';
import { trackContact } from '../tracking/metaPixel';
import { useLanguage } from '../../context/LanguageContext';
import { getWhatsAppLink } from '../../utils/whatsappLink';
const Hero = () => {
  const {
    t,
    language
  } = useLanguage();
  const YOUTUBE_VIDEO_ID = 'K8RA16_6ZoU';
  const handleCtaClick = () => {
    trackContact({
      location: 'hero_primary',
      language,
      action: 'scroll_to_form' // Keep scrolling to form as primary action
    });
  };
  return <section className="py-12 md:py-20 px-4 bg-premium-gradient text-[#F9FAFB] relative overflow-hidden" data-id="element-51">
      {/* Background Pattern Overlay */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] pointer-events-none" data-id="element-52"></div>

      <div className="container mx-auto relative z-10" data-id="element-53">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center" data-id="element-54">
          {/* Content Column */}
          <div className="w-full md:w-1/2 space-y-6 text-center md:text-left" data-id="element-55">
            {/* Social Proof Badge */}
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20 mx-auto md:mx-0" data-id="element-56">
              <div className="flex" data-id="element-57">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-[#FFD700] fill-[#FFD700]" data-id="element-58" />)}
              </div>
              <span className="text-sm font-medium text-gray-200" data-id="element-59">
                {t.hero.badge}
              </span>
            </div>

            {/* Main Headline */}
            <h1 className="font-heading font-extrabold text-3xl md:text-5xl lg:text-6xl leading-tight" data-id="element-60">
              <span className="text-accent block mb-2 text-2xl md:text-3xl uppercase tracking-wider" data-id="element-61">
                {t.hero.headlineAccent}
              </span>
              {t.hero.headline}
            </h1>

            {/* Subheadline */}
            <p className="text-lg md:text-xl text-gray-300 max-w-xl mx-auto md:mx-0 leading-relaxed" data-id="element-62">
              {t.hero.subheadline}
            </p>

            {/* Benefits List (Mobile optimized) */}
            <div className="flex flex-col gap-3 max-w-sm mx-auto md:mx-0 text-left bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-63">
              {t.hero.benefits.map((benefit, index) => <div key={index} className="flex items-start gap-3" data-id="element-64">
                  <CheckCircleIcon className="w-5 h-5 text-success flex-shrink-0 mt-0.5" data-id="element-65" />
                  <span className="text-gray-200 text-sm md:text-base" data-id="element-66">
                    {benefit}
                  </span>
                </div>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4 justify-center md:justify-start items-center" data-id="element-67"></div>

            <p className="text-xs text-gray-400 text-center md:text-left" data-id="element-68">
              {t.hero.response}
            </p>
          </div>

          {/* Video Column */}
          <div className="w-full md:w-1/2 relative" data-id="element-69">
            <div className="absolute -inset-4 bg-accent/20 rounded-full blur-3xl opacity-30 animate-pulse" data-id="element-70"></div>

            {/* Video Container */}
            <div className="relative" data-id="element-71">
              <div className="bg-white p-2 rounded-2xl shadow-2xl" data-id="element-72">
                <YouTubeEmbed videoId={YOUTUBE_VIDEO_ID} className="rounded-xl aspect-[9/16] md:aspect-video" data-id="element-73" />
              </div>
            </div>

            {/* Testimonial Badge — Below video, no overlap */}
            <div className="mt-4 flex justify-center md:justify-end" data-id="element-74">
              <div className="bg-white text-dark px-5 py-3 rounded-xl shadow-lg border-l-4 border-accent inline-flex items-center gap-3" data-id="element-75">
                <div data-id="element-76">
                  <p className="font-bold text-sm md:text-base leading-tight" data-id="element-77">
                    "{t.hero.videoBadge}"
                  </p>
                  <div className="flex items-center gap-2 mt-1" data-id="element-78">
                    <div className="flex" data-id="element-79">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3 h-3 text-accent fill-accent" data-id="element-80" />)}
                    </div>
                    <span className="text-xs text-gray-500" data-id="element-81">
                      Pedro de la Cruz
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 animate-bounce text-white/50 hidden md:block" data-id="element-82">
        <ArrowDownIcon className="w-6 h-6" data-id="element-83" />
      </div>
    </section>;
};
export default Hero;